/**
 * TodaySnapshot — cuatro indicadores compactos.
 *
 * Son NAVEGACIÓN, no un cuadro de mando: cada uno lleva a su bloque y dice de
 * cuánto trabajo se habla. Van en una sola fila baja, sin tarjetas grandes ni
 * cifras de escaparate.
 */
import React from "react";
import { DoorOpen, SignOut, Broom, Wrench } from "@phosphor-icons/react";
import { SURFACE } from "@/pages/admin/pms/v2/V2Primitives";

const COUNTERS = [
  { key: "arrivals", label: "Llegadas", icon: DoorOpen, section: "arrivals" },
  { key: "departures", label: "Salidas", icon: SignOut, section: "departures" },
  { key: "cleaning", label: "Limpiezas", icon: Broom, section: "housekeeping" },
  { key: "issues", label: "Incidencias", icon: Wrench, section: "issues" },
];

export default function TodaySnapshot({ snapshot, visibleSections, onGoToSection }) {
  const rows = COUNTERS
    .filter((c) => visibleSections.includes(c.section))
    .map((c) => ({ ...c, ...valueFor(c.key, snapshot) }));

  if (rows.length === 0) return null;

  return (
    <div
      id="today-snapshot"
      className="grid grid-cols-2 lg:grid-cols-4 gap-2 mb-6 scroll-mt-24"
      data-testid="today-snapshot"
    >
      {rows.map((row) => (
        <button
          key={row.key}
          type="button"
          onClick={() => onGoToSection(row.section)}
          data-testid={`today-counter-${row.key}`}
          title={row.title}
          className={`${SURFACE} px-3 min-h-[44px] flex items-center gap-2 text-left hover:border-stone-400 dark:hover:border-stone-600 transition-colors`}
        >
          <row.icon size={13} weight="bold" className="shrink-0 text-stone-400 dark:text-stone-500" />
          <span className="text-xs text-stone-600 dark:text-stone-300 truncate">{row.label}</span>
          <span className="ml-auto text-sm text-stone-900 dark:text-stone-100 tabular-nums shrink-0">
            {row.value}
          </span>
          {row.alert && (
            <span
              className="w-1.5 h-1.5 rounded-full bg-red-500 shrink-0"
              aria-hidden="true"
              data-testid={`today-counter-${row.key}-alert`}
            />
          )}
        </button>
      ))}
    </div>
  );
}

function valueFor(key, s) {
  if (key === "arrivals") return { value: s.arrivals, title: `${s.arrivals} entradas hoy` };
  if (key === "departures") return { value: s.departures, title: `${s.departures} salidas hoy` };
  if (key === "cleaning") {
    return {
      value: `${s.cleaningPending}/${s.cleaningTotal}`,
      title: `${s.cleaningPending} limpiezas sin terminar de ${s.cleaningTotal}`,
    };
  }
  return {
    value: s.issues,
    alert: s.blockingIssues > 0,
    title: s.blockingIssues > 0
      ? `${s.issues} abiertas · ${s.blockingIssues} bloquea disponibilidad`
      : `${s.issues} abiertas`,
  };
}
